import { isAppleProduct } from './isAppleProduct';

export const makeLocationHref = (lat: number, lng: number, urlQuery?: string) =>
  isAppleProduct()
    ? `http://maps.apple.com/?q=${urlQuery ?? ''}&ll=${lat},${lng}`
    : `https://maps.google.com?q=${lat},${lng}`;
